import { bigQuery } from '@fiverr-private/obs';
import { getBQPayload } from '../utils';
import { EVENT_TYPE } from './constants';

export const trackForkIsClicked = (type) => {
    bigQuery.send(
        getBQPayload({
            type: EVENT_TYPE[type],
            group: 'user_actions',
        })
    );
};
